import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { MdPowerOff, MdPowerSettingsNew, MdSend } from "react-icons/md";
import { socket } from "../../config/socket";
import "./SocketControlPanel.css";

const SocketControlPanel = ({ periodoActual }) => {
  const [status, setStatus] = useState("Desconectado");
  const [events] = useState([
    "ticket-Tickets",
    "ticket-Periodos",
    "ticket-Nomina-Usuarios",
    "ticket-OTROS",
  ]);
  const [receivedMessages, setReceivedMessages] = useState([]);

  // Monitoreo de conexión
  useEffect(() => {
    const handleConnect = () => {
      setStatus("Conectado");
      socket.emit("join:ticket", "ticketsEmitidos");
      socket.emit("join:ticket", "ticketPeriodos");
      socket.emit("join:ticket", "nominaUsuarios");
    };
    const handleReconnect = () => {
      socket.emit("join:ticket", "ticketsEmitidos");
      socket.emit("join:ticket", "ticketPeriodos");
      socket.emit("join:ticket", "nominaUsuarios");
    };

    const handleDisconnect = () => {
      setStatus("Desconectado");
      toast.error("Desconectado del servidor");
    };

    // Verificar conexión existente
    if (socket.connected) {
      handleConnect();
    } else {
      socket.connect();
    }

    // Listeners
    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("connect_error", (err) => {
      toast.error(`Error de conexión: ${err.message}`);
    });

    socket.on("reconnect", async (data) => {
      console.log("Server restarted, attempting to reconnect...");
      handleReconnect();
      toast.error("Reconectando con el servidor");
    });

    return () => {
      // Limpiar listeners pero mantener la conexión
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("reconnect", handleReconnect);
      socket.off("connect_error");
    };
  }, []);

  const handleBroadcast = (eventType) => {
    if (!socket.connected) {
      toast.error("Error: No conectado al servidor");
      return;
    }

    const baseEvent = {
      sala: "ticketsEmitidos",
      data: {
        source: "panel-control",
      },
    };

    switch (eventType) {
      case "ticket-Tickets":
        baseEvent.data = {
          ...baseEvent.data,
        };
        break;

      case "ticket-Periodos":
        baseEvent.sala = "ticketPeriodos";
        // baseEvent.data = {
        //   ...periodoActual,
        // };
        break;

      case "ticket-Nomina-Usuarios":
        baseEvent.sala = "nominaUsuarios";
        baseEvent.data = {
          ...baseEvent.data,
        };
        break;

      case "ticket-OTROS":
        baseEvent.data = {
          ...baseEvent.data,
        };
        break;
    }

    // socket.emit("ticket:updated", baseEvent);
    socket.emit("ticket:update", baseEvent, (response) => {
      if (response?.error) {
        toast.error(`Error: ${response.error}`);
      } else {
        toast.success(`Sincronización ${eventType} emitida`);
        // ... resto del código
      }
    });
    toast.success(`Sincronización ${eventType} emitida`);

    setReceivedMessages((prev) => [
      ...prev,
      {
        event: eventType,
        data: baseEvent,
        timestamp: new Date().toISOString(),
        id: Date.now() + Math.random(),
        type: "sent",
      },
    ]);
  };

  return (
    <div className="socket-control-panel">
      <div className="panel-header">
        <h2>Panel de Sincronización Central</h2>
        <div className="connection-controls">
          <div
            className={`status-badge ${
              status === "Conectado" ? "connected" : "disconnected"
            }`}
          >
            {status === "Conectado" ? (
              <MdPowerSettingsNew style={{ marginRight: 5 }} />
            ) : (
              <MdPowerOff style={{ marginRight: 5 }} />
            )}
            {status}
          </div>
          <button
            onClick={() => socket.connect()}
            className="control-btn connect-btn"
            disabled={status === "Conectado"}
          >
            Conectar
          </button>
          <button
            onClick={() => socket.disconnect()}
            className="control-btn disconnect-btn"
            disabled={status !== "Conectado"}
          >
            Desconectar
          </button>
        </div>
      </div>

      <div className="event-section">
        <h3>Acciones de Sincronización</h3>
        <div className="event-grid">
          {events.map((event) => (
            <div key={event} className="event-card">
              <div className="event-header">
                <span className="event-name">
                  {event.replace("ticket-", "").toUpperCase()}
                </span>
              </div>
              <button
                onClick={() => handleBroadcast(event)}
                className="broadcast-btn"
                disabled={status !== "Conectado"}
              >
                <MdSend style={{ marginRight: 5 }} />
                Sincronizar
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="log-section">
        <h3>Registro de Sincronizaciones</h3>
        <div className="log-container">
          {receivedMessages
            .slice(-10)
            .reverse()
            .map((msg) => (
              <div key={msg.id} className="log-entry">
                <div className="log-meta">
                  <span className="log-timestamp">
                    {new Date(msg.timestamp).toLocaleTimeString()}
                  </span>
                  <span className="log-event">{msg.event}</span>
                  <span className="log-source">Matriz</span>
                </div>
                <pre className="log-data">
                  {JSON.stringify(msg.data, null, 2)}
                </pre>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SocketControlPanel;
